import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SignOutIcon } from 'shared/icons';

export const SignOutButton: FC<{ onClick: () => void }> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <button
      aria-label={t('action:signOut')}
      onClick={onClick}
      className="flex w-full flex-row items-center gap-2 rounded-md px-3 py-2 text-gray-400 transition-all hover:bg-white/10 lg:flex-col lg:gap-1 lg:bg-lightBlue lg:p-0 lg:text-gray"
    >
      <div className="flex-center h-7 w-7 rounded-full transition-all lg:h-10 lg:w-10 lg:bg-white">
        <SignOutIcon className="h-4 w-4 lg:h-5 lg:w-5" />
      </div>
      <span className="lg:text-xs">{t('action:signOut')}</span>
    </button>
  );
};
